import {Filter} from './Filter'

/**
 * It allows you to filter products into a specific category
 */
export class CategoryFilter implements Filter {
    enableMultiple: boolean
    urlParam: string
    /** Filter value, product category id to filter */
    value: string;

    /** @param filterValue Product category id to filter */
    constructor(filterValue: string) {
        this.enableMultiple = true
        this.urlParam = 'filter'
        this.value = filterValue
    }
}
